
export default {
  user: {
    authenticated: false
  },

  login (context, username, password, successCB, errorCB) {
    // if success
    var self = this
    var token = btoa(username + ':' + password)
    context.$axios.defaults.headers.common['Authorization'] = `Basic ${token}`

    context.$axios.get(process.env.API_URL)
      .then(function (response) {
        localStorage.setItem('auth_token', token)
        self.user.authenticated = true
        successCB(response)
      })
      .catch(function (error) {
        errorCB(error)
      })
  },

  logout (context) {

  },

  checkAuth () {
    var token = localStorage.getItem('auth_token')
    if (token) {
      this.user.authenticated = true
    } else {
      this.user.authenticated = false
    }
  },

  getAuthToken () {
    return localStorage.getItem('auth_token')
  }
}



// WEBPACK FOOTER //
// ./src/auth/index.js